import { createClient } from '@supabase/supabase-js'
import { makeDataFetch } from './lib/dataFetch'

// No fallback, deliberately: a build must fail rather than silently talk to
// the wrong Supabase project. scripts/check-supabase-env.js (run as an npm
// "prebuild" hook) already refuses to let the build reach this file at all
// if either var is missing — this throw is defense in depth for the case
// where react-scripts gets invoked directly, bypassing that hook.
const url = process.env.REACT_APP_SUPABASE_URL?.trim()
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY?.trim()

if (!url || !anonKey) {
  throw new Error(
    'REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY must both be set — see README.md.'
  )
}

// Every write to the data or file API through this client (insert, update, delete, upsert, a database function)
// drops what the pages remembered in memory (lib/dataCache.js), when it starts and when it ends: see lib/dataFetch.ts.
export const supabase = createClient(url, anonKey, { global: { fetch: makeDataFetch() } })
